"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : VALUE HIGHLIGHTER : STYLES --------------- ++++++++++ */


var _default = {
  valuehighlighter: {
    display: 'flex',
    flexDirection: function flexDirection(props) {
      return props.direction || 'column';
    },
    background: 'rgb(250, 251, 252)',
    borderRadius: (0, _index.pxToEm)(4),
    border: (0, _index.replacePXinStringWithEM)('2px solid rgb(238, 242, 246)'),
    color: 'rgb(13, 93, 153)',
    fontSize: (0, _index.pxToEm)(14),
    padding: (0, _index.pxToEm)(15),
    overflow: 'auto',
    height: function height(props) {
      return props.scrollable === true && props.minHeight ? (0, _index.replacePXinStringWithEM)(props.minHeight) : 'auto';
    },
    minHeight: function minHeight(props) {
      return props.minHeight ? (0, _index.replacePXinStringWithEM)(props.minHeight) : 'auto';
    },
    '& .highlighted': {
      color: 'rgb(223, 29, 29)'
    }
  }
};
exports.default = _default;